// src/components/list/CorrelationFeelingItem.tsx

import {
  Avatar,
  Checkbox,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { MouseEvent } from 'react'

import { SensorId, SensorName, SensorStatus, SensorType } from '@/types/domain'

import { SensorIcon } from '../../api'
import {
  OperatorData,
  useOperator,
  useSensorName,
  useSensorStatus,
  useSensorType,
} from '../../hooks'

type CorrelationFeelingItemProps = {
  id: SensorId
  onClick: (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void
  selected: boolean
}

export const CorrelationFeelingItem = ({
  id,
  onClick,
  selected,
}: CorrelationFeelingItemProps) => {
  const name: SensorName = useSensorName(id)
  const opData: OperatorData = useOperator()
  const status: SensorStatus = useSensorStatus(id)
  const type: SensorType = useSensorType(id)

  const src: string = SensorIcon(type, status)
  const title: string = opData?.isAdmin ? `Sensor ID: ${id}` : ''

  return (
    <ListItem sx={{ p: 0, width: 1 }}>
      <ListItemButton onClick={onClick} selected={selected}>
        <ListItemAvatar>
          <Tooltip title={title}>
            <Avatar src={src} />
          </Tooltip>
        </ListItemAvatar>

        <ListItemText primary={name} />

        <Checkbox color={'primary'} checked={selected} />
      </ListItemButton>
    </ListItem>
  )
}
